import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { APP_ROUTES } from '@app/constants';
import { AppNotification } from '@app/helpers';
import { AuthService, LocalStorageService } from '@app/services';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit, OnDestroy {

  forgotPasswordForm: FormGroup = new FormGroup({});
  emailSent: boolean = false;

  constructor(
    private authService: AuthService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.forgotPasswordForm = new FormGroup({
      email: new FormControl('', [Validators.required, Validators.email]),
    });
  }

  submitForgotPassword() {
    this.authService.forgotPassword(this.forgotPasswordForm?.value.email).subscribe({
      next: (res: any) => {
        this.emailSent = true;
      },
      error: (error) => {
        console.log(error)
        AppNotification.error(error.error.data)
      }
    })
  }

  ngOnDestroy(): void {

  }

}
